import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
    selector: 'lib-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent {
  @Input() checked!: boolean;
  @Output() valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  checkboxSize = input<string>();
  disabled = input<boolean>(false);

  onChange() {
    this.checked = !this.checked;
    this.valueChanged.emit(this.checked);
  }
}

